import { INSERT_STALL_DESIGN_REQUEST, UPDATE_STALL_DESIGN_REQUEST,GET_STALL_DESIGN_REQUEST_LIST,GET_STALL_DESIGN_REQUEST_DETAILS, } from "../../utils/constants"


const initialState = [];

function stallDesignRequestReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case INSERT_STALL_DESIGN_REQUEST:
      return [...state, payload];
    case UPDATE_STALL_DESIGN_REQUEST:
      return [...state, payload];
    case GET_STALL_DESIGN_REQUEST_LIST:
      return [...state, payload];
    case GET_STALL_DESIGN_REQUEST_DETAILS:
      return [...state, payload];
    
    default:
      return state;
  }
};

export default stallDesignRequestReducer;